import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        occurrence: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        classifiers: '<'
    },
    template: `
        <div class="form">
            <div class="heading01">
                <p class="desc">{{ 'occurrence.employee.targets.notification' | translate }}</p>
                <ul class="actions01">
                    <li class="primary">
                        <a class="btn ico-filter" ng-click="vm.toggleFilter = !vm.toggleFilter">{{ 'targetedFilter.Filter' | translate }}</a>
                    </li>
                </ul>
            </div>
            <modals-courses-occurrence-employee-targeted-filter
                toggle-filter="vm.toggleFilter"
                classifiers="vm.classifiers"
                list="vm.list"
                default-filter="vm.defaultFilter"
                versions="vm.versions"
            />
            <modals-courses-occurrence-employee-table
                enable-all="true"
                list="vm.list"
                user-ids="vm.userIds"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
                custom-options="[1000,2500]"
                ng-class="{true: 'loader01', false: ''}[vm.loading]"
            />
        </div>
    `
})
export default class {
    constructor (DATATABLES, MomentService, CourseResource, ListFactory, CourseVersionResource) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.CourseVersionResource = CourseVersionResource;
        this.loading = false;
        this.list = ListFactory.createWithPagination(CourseResource.trainingNeedUsers.bind(CourseResource));
        this.list.pagination.perPage = 25;
    }

    $onInit () {
        this.defaultFilter = {
            id: this.occurrence.courseId,
            siteId: this.occurrence.siteId,
            'siteIds[]': this.occurrence.sites.map(site => site.id),
            occurrenceId: this.occurrence.id,
            isPlanningRelatedSearch: false,
            excludePlannedUsers: true,
            excludeApgUsers: true
        };
        this.loading = true;
        this.list.fetch(this.defaultFilter).finally(() => {
            this.loading = false;
        });

        this.CourseVersionResource.query({
            courseId: this.occurrence.courseId,
            includeArchived: true,
            pageSize: 0
        }).$promise.then(versions => {
            this.versions = versions;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/employee/targets/index.js